import { Contract } from '../business/api/contracts/contract/contract';

export class PortfolioHelper {
    public static getLoggedContract(contracts: Contract[]): Contract | undefined {
        return contracts.find((contract: Contract) => contract.telco?.state?.toUpperCase() === 'LOGGED');
    }

    public static getContractByCid(contracts: Contract[], cid: string): Contract | undefined {
        return contracts.find((contract: Contract) => contract.cid === cid);
    }

    public static getVimEligibleContract(contracts: Contract[]): Contract | undefined {
        return contracts.find((contract: Contract) => contract.telco?.state?.toUpperCase() === 'VIM_ELIGIBLE');
    }
}
